<template>
  <v-container style="max-height: 379px"
               fluid
               class="pa-0">
    <v-row class="full-height"
           no-gutters>
      <v-col cols="12"
             class="full-height d-flex justify-center flex-wrap">
        <!-- inicio de header de tabla -->
        <div class="da-table-header d-flex align-center justify-center col-11 px-0">
          <div class="da-table-header-item col-3 d-flex justify-center align-center">
            ID vaca
          </div>
          <div class="da-table-header-item col-3 d-flex justify-center align-center">
            Raza
          </div>
          <div class="da-table-header-item col-2 d-flex justify-center align-center">
            DIM
          </div>
          <div class="da-table-header-item col-4 d-flex justify-center align-center">
            Grupo
          </div>
        </div>
        <!-- fin de header de tabla -->
        <!-- inicio de contenido de tabla -->
        <v-row no-gutters
               class="alert-table-row-container col-12 pa-0"
               id="row-container"
               justify="center"
               align-content="start">
          <v-col cols="11" class="d-flex align-center justify-center alert-table-row"
                 v-for="(item, index) in croppedHistory" :key="index"
                 v-bind:class="[{'table-row-others' : index === 0}]">
            <div class="col-3 d-flex align-center justify-center da-row-item" style="position:relative;">
              <i class="da-table-icon"></i>
              {{item.id}}
            </div>
            <div class="col-3 d-flex align-center justify-center da-row-item">
              {{item.breed}}
            </div>
            <div class="col-2 d-flex align-center justify-center da-row-item">
              {{item.dim}}
            </div>
            <div class="col-4 d-flex align-center justify-center da-row-item" style="position:relative;">
              {{item.group}}
              <v-switch v-model="item.alertSwitch"
                        class="ma-2 da-switch-table">
              </v-switch>
            </div>
          </v-col>
        </v-row>
        <!-- fin de contenido de tabla -->
        <v-row no-gutters class="da-table-pagination col-11 pa-0">
          <v-col cols="12"
                 style="position: relative;"
                 class="d-flex align-center pa-0 justify-center">
            <v-pagination v-model="pageSelected"
                          class="col-6"
                          :disabled="itemsPage === 0"
                          :length="itemsPage"
                          :next-icon="nextIcon"
                          :prev-icon="prevIcon"
                          total-visible="10"
            >
            </v-pagination>
            <v-autocomplete :items="pageItems"
                            :disabled="itemsPage === 0"
                            return-object
                            outlined
                            hide-details
                            dense
                            style="position: absolute; right: 24px"
                            v-model="pageItem"
                            value="number"
                            item-text="formattedText">
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
    export default {
        name: "SmartTable",
        data () {
            return {
                success: false,
                pageSelected: 1,
                nextIcon: 'navigate_next',
                prevIcon: 'navigate_before',
                pageItem: {number: 5, formattedText: '5 eventos por hoja'},
                itemsToShow: [
                    {
                        id: '0001',
                        dim: 190,
                        breed: 'Holstein',
                        group: 'General',
                        alertSwitch: false,
                    },
                    {
                        id: '0002',
                        dim: 190,
                        breed: 'Holstein',
                        group: 'General',
                        alertSwitch: false,
                    },
                    {
                        id: '0003',
                        dim: 190,
                        breed: 'Holstein',
                        group: 'General',
                        alertSwitch: false,
                    },
                    {
                        id: '0004',
                        dim: 190,
                        breed: 'Holstein',
                        group: 'General',
                        alertSwitch: false,
                    },
                    {
                        id: '0004',
                        dim: 190,
                        breed: 'Holstein',
                        group: 'General',
                        alertSwitch: false,
                    },
                    {
                        id: '0004',
                        dim: 190,
                        breed: 'Holstein',
                        group: 'General',
                        alertSwitch: false,
                    },
                ],
                pageItems: [
                    {number: 5, formattedText: '5 eventos por hoja'},
                    {number: 20, formattedText: '20 eventos por hoja'},
                    {number: 30, formattedText: '30 eventos por hoja'},
                    {number: 40, formattedText: '40 eventos por hoja'},
                ],
            }
        },
        computed: {
            /**
             * Calcula el número de páginas que mostrará la paginación
             */
            itemsPage() {
                return Math.floor(this.itemsToShow.length / this.pageItem.number) + 1;
            },
            isActive(index) {
              return index === 0;
            },
            /**
             * Regresa los elementos de la bitácora de acuerdo a los eventos
             * por hoja seleccionados por el usuario
             */
            croppedHistory() {
                return this.itemsToShow.slice((this.pageSelected - 1) * this.pageItem.number, this.pageSelected * this.pageItem.number);
            },
        },
        methods: {
            orderByID() {

            },
        }
    }
</script>

<style scoped>
  @import '../style/SmartTable.css';
</style>